export const s3 = (path) => {
    let BASE_URL = '/media'
    if (process.env.NODE_ENV === 'production') {
        BASE_URL = 'https://br1.bravoready.com'
    }
    return `${BASE_URL}${path}`
}
